module.exports = __webpack_public_path__ + "img/left.4cb2fdd3.png";